<template>
    <Box :width="'580px'" :color="'#8a66c7'" :background="'#F5E9FF'">
        <template #title>Labelling</template>
        <template #content>
            <div style="width: 100%; display: flex; flex-direction: row; gap: 10px; padding: 10px; height: 430px;">
                <div style="display: flex; gap: 8px; width: 320px; height: 100%; flex-direction: column;">
                    <div class="playground"  @contextmenu.prevent @mousedown.left.stop="select" ref="playground">
                        <div v-if="!data" @mousedown.stop.prevent style="width: 100%; height: 100%; background: rgba(200, 200, 200, 0.3); pointer-events: none; z-index: 2; border-radius: 0; position: absolute; cursor: default; display: flex; justify-content: center; align-items: center; font-size: 18px; color: #777; font-weight: 600;">
                            Select an image
                        </div>
                        <div class="cord" v-if="mouseCord " :style="{left: `${mouseCord.x}px`, top: `${mouseCord.y}px`}">
                            {{mouseCord.x}},{{mouseCord.y}}
                        </div>
                        <div class="background">
                            <!-- <span class="lineHori" v-if="!data"/> 
                            <span class="lineVert" v-if="!data"/> -->
                        </div>
                        <div class="backgroundImage" v-if="data">
                            <ImageCanvas :imageData="data.imageData" :size="320"></ImageCanvas>
                        </div>
                        <Region v-for="region in regions" :key="region" :region="region" :color="trainer.getClass(region.classId)?.color"
                            :animated="!mouseCord" :selecting="region === selectingRegion" :selected="region === selectedRegion" 
                            @center="move($event, region)" @border="resize(...$event, region)" 
                            @click.left="selectedRegion = region" @click.right="data.removeRegion(region)">
                            {{trainer.getClass(region.classId)?.name}}
                        </Region>
                    </div>
                    <div style="width: 100%; height: 60px; display: flex; gap: 25px;">
                        <div class="mouseTipsContainer">
                            Mouse Tips
                            <div class="mouseTips"> <img src="../../assets/mouseL2.png"> Select </div>
                            <div class="mouseTips">  <img src="../../assets/mouseR2.png"> Remove </div>
                        </div>
                        <div class="mouseTipsContainer">
                            Background
                            <div class="mouseTips"> <img src="../../assets/background3.png"> Blank </div>
                            <div class="mouseTips">  <img src="../../assets/camera.png"> Camera </div>
                        </div>
                    </div>
                </div>
                <div class="labelsContainer">
                    <span> 
                        Classes 
                        <div style="display: flex; gap: 8px; align-items: center; font-size: 15px;">
                            {{ numClass }} / {{ maxNumClass }}
                            <button class="add" @click="addClassEvt" :class="{disabled: numClass >= maxNumClass}">
                                <img src="../../assets/add.png" style="width: 100%; ">
                            </button>
                        </div>
                    </span>
                    <div class="labels">
                        <Label v-for="cls in trainer.getClasses()" :key="cls"
                            :value="cls" 
                            :isActive="selectedClass == cls" 
                            :count="trainer.countDataByClass(cls.id) "
                            @click="selectedClass = cls" 
                            @delete="removeClassEvt(cls.id)"/>
                    </div>
                </div>
            </div>
        </template>
    </Box>
</template>

<script scoped>
import ImageCanvas from '@/tm/ImageCanvas.vue';
import {Box} from '@/index.js'
import { ObjectDetectionRegion, ObjectDetectionData, ObjectDetectionTrainer } from '../../scripts/ObjectDetection';
import Region from './Region.vue';
import Label from './Label.vue';

export default{
    props: {
        trainer: {
            type: ObjectDetectionTrainer,
            default: new ObjectDetectionTrainer()
        },
        data: {
            type: ObjectDetectionData,
            default: new ObjectDetectionData()
        },
        showDemoObject: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            mouseCord: null,

            selectedRegion: null,
            selectedRegions: [],
            selectingRegion: null,

            demoRegion: new ObjectDetectionRegion(-1, 90, 90, 150, 150),

            maxNumClass: 6,
            selectedClass: null,
        }
    },
    components:{
        ImageCanvas,
        Box,
        Label,
        Region
    },
    methods: {
        calculatePlaygroundCord(x, y){
            const playground = this.$refs.playground.getBoundingClientRect();
            const clamp = (num, max) => Math.min(Math.max(num, 0), max)
            let [roundX, roundY] = [Math.round(x - playground.left), Math.round(y - playground.top)]
            const clampX = clamp(roundX, playground.width)
            const clampY = clamp(roundY, playground.height)
            return [clampX, clampY]
        },
        dragEventConstructor(mousemoveEvt, mouseupEvt, event){
            const _mouseupEvt = (event) => {
                mouseupEvt(event);
                removeEventListener('blur', _mouseupEvt)
                removeEventListener('mouseup', _mouseupEvt)
                removeEventListener('mousedown', _mouseupEvt)
                removeEventListener('mousemove', mousemoveEvt)
            }
            
            addEventListener('blur', _mouseupEvt)
            addEventListener('mouseup', _mouseupEvt)
            addEventListener('mousedown', _mouseupEvt)
            addEventListener('mousemove', mousemoveEvt)
            
            mousemoveEvt(event)
        },
        select(event){
            if(this.selectingRegion || !this.selectedClass){
                return
            }

            const selectingEvt = (event) => {
                requestAnimationFrame(() => {
                    const [x, y] = this.calculatePlaygroundCord(event.clientX, event.clientY)
                    this.mouseCord = {x: x, y: y}

                    if (!this.selectingRegion) {
                        this.selectingRegion = new ObjectDetectionRegion(this.selectedClass.id, x, y, x, y)
                    } else {
                        this.selectingRegion.x2 = x
                        this.selectingRegion.y2 = y
                    }
                    this.selectingRegion.refigure()
                })
            }

            const selectionEndEvt = () => {
                requestAnimationFrame(() => {
                    const regionToAdd = this.selectingRegion
                    this.mouseCord = null
                    this.selectingRegion = null

                    if (regionToAdd.isValid() && this.data) {
                        this.data.addRegion(regionToAdd)
                    }
                })
            }

            this.dragEventConstructor(selectingEvt, selectionEndEvt, event)
        },
        resize(event, options = {top : false, bottom: false, left: false, right: false}, region){
            this.selectedRegion = region
            if (!region || !(options.top || options.bottom || options.left || options.right)) {
                return
            }

            const origin = {...region}
            let refY, refX
            if (options.top) refY = (region.y2 < region.y1) ? 'y2' : 'y1';
            if (options.bottom) refY = (region.y2 > region.y1) ? 'y2' : 'y1';
            if (options.left) refX = (region.x2 < region.x1) ? 'x2' : 'x1';
            if (options.right) refX = (region.x2 > region.x1) ? 'x2' : 'x1';

            const resizeEvt = (event) => {
                requestAnimationFrame(() => {
                    const [x, y] = this.calculatePlaygroundCord(event.clientX, event.clientY)
                    this.mouseCord = {x: x, y: y}

                    if (refY) {
                        region[refY] = y
                    }
                    if (refX) {
                        region[refX] = x
                    }
                    region.refigure()
                })
            }
            
            const resizeEndEvt = () => {
                requestAnimationFrame(() => {
                    if(!region.isValid()) {
                        Object.assign(region, origin)
                    }
                    this.mouseCord = null
                })
            }

            this.dragEventConstructor(resizeEvt, resizeEndEvt, event)
        },
        move(event, region){
            if (!region) {
                return
            }

            const origin = {...region}
            const { clientX: mouseStartX, clientY: mouseStartY } = event;

            const moveEvt = (event) => {
                requestAnimationFrame(() => {
                    const { clientX: mouseX, clientY: mouseY } = event;
                    let xDiffMouse = mouseX - mouseStartX, yDiffMouse = mouseY - mouseStartY;
                    const xLeft = origin.left + xDiffMouse
                    const xRight = xLeft + origin.width
                    const yTop = origin.top + yDiffMouse
                    const yBottom = yTop + origin.height

                    if (yTop < 0) yDiffMouse =  -origin.top;
                    if (yBottom > 320) yDiffMouse = 320 - origin.top - origin.height;
                    if (xLeft < 0) xDiffMouse =  -origin.left;
                    if (xRight > 320) xDiffMouse =  320 - origin.left - origin.width;

                    region.x1 = origin.x1 + xDiffMouse
                    region.x2 = origin.x2 + xDiffMouse
                    region.y1 = origin.y1 + yDiffMouse
                    region.y2 = origin.y2 + yDiffMouse

                    region.refigure()
                })
            }
            
            const moveEndEvt = () => {
                requestAnimationFrame(() => {
                    this.mouseCord = null
                })
            }

            this.dragEventConstructor(moveEvt, moveEndEvt, event)
        },
        addClassEvt(){
            if (this.trainer.classes.length < 6) {
                this.trainer.addClass()
            }
            this.selectedClass = this.trainer.classes[this.trainer.classes.length - 1]
        },
        removeClassEvt(clsId){
            this.trainer.removeClass(clsId)
            if (this.selectedClass.id == clsId) {
                this.selectedClass = null
            }
        }
    },
    computed:{
        regions(){
            const result = []
            if ( this.data ) {
                result.push(...this.data.regions)
            }
            if (this.selectingRegion) {
                result.push(this.selectingRegion)
            }
            return result
        },
        numClass(){
            return this.trainer.classes.length
        }
    },
    mounted(){
        if (!this.selectedClass) {
            this.selectedClass = this.trainer.classes[0]
        }
    }
}
</script>

<style scoped>
*{
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
}
.container{
    width: 520px; height: max-content; background: #e7f0fe; border: 1px solid #dcdcdc; padding: 15px; display: flex; flex-direction: column; gap: 10px;
}

.playground{
    width: 320px; height: 320px; 
    cursor: crosshair;
    box-sizing: content-box;
    border-radius: 0px;
    border: none;
    z-index: 1;
}
.playground .cord{
    padding: 3px; position: absolute; width: max-content; pointer-events: none;
    transform: translate(3px, 3px);
    z-index: 1;
    font-size: 12px;
    background: #8A66C7;
    color: white;
    border-radius: 0;
}
.playground .lineHori{
    width: 100%; height: 0; border-top: 1.5px dotted #bbb; 
    position: absolute; top: 50%; transform: translateY(-50%);
}
.playground .lineVert{
    width: 0; height: 100%; border-left: 1.5px dotted #bbb; 
    position: absolute; left: 50%; top: 0; transform: translateX(-50%); 
}
.playground .background{
    width: 100%; height: 100%;
    border: 3px dashed #bbb; border-radius: 0px;
    position: absolute;
    top: 0; left: 0;
    pointer-events: none;
}
.playground .backgroundImage{
    width: 100%; height: 100%; border-radius: 0; z-index: -1;
}


.labelsContainer{
    display: flex; flex-direction: column; gap: 5px; color: #8A66C7; flex: 1; padding: 3px;
    overflow-y: hidden;
    max-height: 100%;
}
.labelsContainer span{
    padding: 0 5px; font-weight: 600; font-size: 16px;
    display: flex; justify-content: space-between;
}
.labelsContainer span button{
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    color: #8A66C7;
    font-weight: 600;
    font-size: 16px;
    border: 3px solid #8A66C7;
}
.labelsContainer .labels{
    display: flex; flex-direction: column; gap: 7.5px; color: #8A66C7; 
    font-weight: 600; font-size: 16px; flex: 1; padding: 3px; 
    padding-right: 5px;
    /* overflow-x: visible */;
    /* overflow-y: scroll; */
}
.labelsContainer .add{
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #8A66C7;
    color: #8A66C7;
    font-weight: 600;
    background: white;
    width: 20px; height: 20px;
    padding: 0;
    border-radius: 3px;
}
.labelsContainer .add:hover{
    background: #8A66C7;
    color: white;
}
.labelsContainer .add.disabled{
    pointer-events: none;
    filter: grayscale(1)
}

.mouseTipsContainer{
    display: flex; gap: 10px; flex-direction: row; height: 100%; justify-content: space-between; padding: 3px;
    flex-direction: column;
    width: max-content;
    font-size: 16px; font-weight: 600; color: #8A66C7;
}
.mouseTips{
    display: flex; height: 25px; align-items: center; gap: 5px; color: #8A66C7
}
.mouseTips img{
    width: auto; height: 20px
}
</style>